var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 202 170.3",
    style: {
      enableBackground: "new 0 0 202 170.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000054258019692922655660000009935660905316570539_);}\r\n\t.st2{fill:url(#SVGID_00000110458390356856459950000007852758808768596151_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.1334,
    y1: 27.0445,
    x2: 166.9335,
    y2: 143.0135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.05
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.9,128.6L115.8,7.2c-2.2-5.2-8.1-7.6-13.3-5.4L41.7,27.4c-5.2,2.2-7.6,8.1-5.4,13.3l51.2,121.4 c2.2,5.1,8.1,7.6,13.3,5.4l60.8-25.6C166.7,139.7,169.1,133.8,166.9,128.6z M129.4,149.8c-3.7,1.6-8.1-0.2-9.6-3.9 c-1.6-3.7,0.2-8.1,3.9-9.6c3.7-1.6,8.1,0.2,9.6,3.9C134.9,143.9,133.1,148.3,129.4,149.8z M89.1,146.6L42.4,35.9L108,8.2l46.7,110.7 L89.1,146.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142890030465146537010000014523241055277146529_",
    gradientUnits: "userSpaceOnUse",
    x1: -6.1198,
    y1: 95.8645,
    x2: 149.9241,
    y2: 172.4679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142890030465146537010000014523241055277146529_)"
    },
    d: "M44.3,148.8c-6.5-3.2-19.5-11.2-26.9-27.1 c-7.6-16.4-5.2-32-2.9-40l3.3,8.4c0.3,0.8,1.2,1.2,2,0.9c0.8-0.3,1.2-1.2,0.9-2l-4.5-11.3l-1.2-3l-2.7,1.7L1.7,83.2 c-0.7,0.5-0.9,1.4-0.5,2.2l0,0c0.5,0.7,1.4,0.9,2.2,0.5l8.1-5.2c-1.1,3.8-1.9,8-2.2,12.1c-0.9,10.7,0.9,20.9,5.3,30.3 c7.8,16.8,21.5,25.3,28.4,28.6c0.8,0.4,1.7,0,2.1-0.8l0,0C45.4,150.1,45,149.2,44.3,148.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118374012967536994190000016012353225833490869_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.8626,
    y1: -10.7012,
    x2: 198.9065,
    y2: 65.9022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118374012967536994190000016012353225833490869_)"
    },
    d: "M157.7,17.5c6.5,3.2,19.5,11.2,26.9,27.1 c7.6,16.4,5.2,32,2.9,40l-3.3-8.4c-0.3-0.8-1.2-1.2-2-0.9c-0.8,0.3-1.2,1.2-0.9,2l4.5,11.3l1.2,3l2.7-1.7l10.6-6.9 c0.7-0.5,0.9-1.4,0.5-2.2l0,0c-0.5-0.7-1.4-0.9-2.2-0.5l-8.1,5.2c1.1-3.8,1.9-8,2.2-12.1c0.9-10.7-0.9-20.9-5.3-30.3 c-7.8-16.8-21.5-25.3-28.4-28.6c-0.8-0.4-1.7,0-2.1,0.8l0,0C156.6,16.2,157,17.1,157.7,17.5z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.95b8ab375bdfa03f69761bd49bef6df5.svg";
export { ForwardRef as ReactComponent };